module.exports = __webpack_public_path__ + "static/media/main_paper_text.a5f5c305.png";